export const dashboardTranslations = {
  title: "แดชบอร์ด",
  subtitle: "นี่คือสิ่งที่เกิดขึ้นในวันนี้",
  welcomeUser: "ยินดีต้อนรับ",

  // Greetings
  goodMorning: "สวัสดีตอนเช้า",
  goodAfternoon: "สวัสดีตอนบ่าย",
  goodEvening: "สวัสดีตอนเย็น",

  // Quick actions
  quickActions: "การดำเนินการด่วน",
  newOrder: "ออเดอร์ใหม่",
  newItem: "สินค้าใหม่",
  newCustomer: "ลูกค้าใหม่",
  newInvoice: "ใบแจ้งหนี้ใหม่",

  // Quick action modules
  ordersModule: "ออเดอร์",
  productsModule: "สินค้า",
  customersModule: "ลูกค้า",
  inventoryModule: "คลังสินค้า",
  allModules: "ทั้งหมด",
  settings: "ตั้งค่า",

  // Modules
  modules: "โมดูล",
  items: "รายการ",

  // Module descriptions
  productsDescription: "จัดการแคตตาล็อกและราคา",
  inventoryDescription: "ติดตามสต็อกและคลังสินค้า",
  customersDescription: "จัดการความสัมพันธ์ลูกค้า",
  ordersDescription: "ดำเนินการขายและใบแจ้งหนี้",
  pointRewardsDescription: "โปรแกรมสะสมแต้มและรางวัล",
  settingsDescription: "กำหนดค่าพื้นที่ทำงาน",

  // Stats
  totalCustomers: "ลูกค้า",
  totalItems: "สินค้า",
  ordersToday: "ออเดอร์วันนี้",
  pendingDeliveries: "รอจัดส่ง",
  lowStock: "สต็อกต่ำ",
  pendingInvoices: "ใบแจ้งหนี้ค้าง",

  // Action required
  actionRequired: "ต้องดำเนินการ",

  // Needs attention
  needsAttention: "ต้องดำเนินการ",

  // Recent activity
  recentActivity: "กิจกรรมล่าสุด",

  // News section
  news: "ข่าวสาร",
  newFeature: "ฟีเจอร์ใหม่",
  siteCanvas: "Site Canvas",
  siteCanvasDescription: "สร้างหน้าร้านที่สวยงามด้วยเครื่องมือลากและวาง สร้าง ปรับแต่ง และเผยแพร่ได้ในไม่กี่นาที",
  trySiteCanvas: "ลองใช้ Site Canvas",

  // Storefront card
  yourStorefront: "หน้าร้านของคุณ",
  openStorefront: "เปิด",
  copyUrl: "คัดลอก URL",

  // Shortcuts
  shortcuts: "ทางลัด",
  customers: "ลูกค้า",
  orders: "คำสั่งซื้อ",
  stockEntry: "รายการสต็อก",

  // Setup state (Epic 02)
  setupSubtitle: "กำลังเตรียมพื้นที่ทำงานของคุณ",
  setupCardTitle: "กำลังตั้งค่าพื้นที่ทำงาน",
  setupCardDescription: "ทีมงาน Zaviago กำลังเตรียมระบบให้พร้อมสำหรับธุรกิจของคุณ เราจะแจ้งให้ทราบเมื่อทุกอย่างพร้อมแล้ว",
  setupContactEmail: "support@zaviago.com",

  // Onboarding state (Epic 03)
  onboardingSubtitle: "พื้นที่ทำงานของคุณพร้อมแล้ว",
  onboardingGetStarted: "เริ่มเลย",
  onboardingStepProgress: "ความคืบหน้าการตั้งค่า",

  // Onboarding step titles (Epic 03)
  onboardingStepCompany: "ตั้งค่าบริษัทของคุณ",
  onboardingStepCompanyDesc: "เพิ่มรายละเอียดบริษัทของคุณ",
  onboardingStepWarehouse: "สร้างคลังสินค้า",
  onboardingStepWarehouseDesc: "ตั้งค่าสถานที่จัดเก็บสินค้า",
  onboardingStepItems: "เพิ่มสินค้าแรกของคุณ",
  onboardingStepItemsDesc: "สร้างสินค้าเพื่อเริ่มขายบนร้านค้าและระบบ ERP",
  onboardingStepPricing: "ตั้งค่าราคา",
  onboardingStepPricingDesc: "สร้างรายการราคา",
  onboardingStepCustomers: "เพิ่มลูกค้า",
  onboardingStepCustomersDesc: "สร้างลูกค้ารายแรกของคุณ",

  // Section labels (Epic 03/04)
  applicationsLabel: "แอปพลิเคชัน",

  // Compact news label (Epic 04)
  latestNews: "ข่าวล่าสุด",

  // Transition toast (Epic 05)
  setupComplete: "ตั้งค่าเสร็จแล้ว! พื้นที่ทำงานพร้อมใช้งาน",

  // Intent paths — onboarding redesign (Plan 40, Epic 03)
  intentPathQuestion: "คุณต้องการทำอะไรเป็นอย่างแรก?",
  intentPathSelling: "เริ่มขายสินค้า",
  intentPathSellingDesc: "เพิ่มสินค้าและเริ่มรับออเดอร์",
  intentPathChat: "แชทกับลูกค้า",
  intentPathChatDesc: "เชื่อมต่อกับลูกค้าผ่านข้อความ",
  intentPathContacts: "จัดระเบียบผู้ติดต่อ",
  intentPathContactsDesc: "ติดตามลูกค้าและลีดของคุณ",
  intentPathExploreAll: "หรือสำรวจทั้งหมด",
  intentPathCompleted: "เสร็จเรียบร้อย!",

  // Intent path step labels
  intentStepAddProduct: "เพิ่มสินค้าแรกของคุณ",
  intentStepAddProductDesc: "สร้างสินค้าในแคตตาล็อก",
  intentStepAddCustomer: "เพิ่มลูกค้า",
  intentStepAddCustomerDesc: "สร้างข้อมูลลูกค้ารายแรก",
  intentStepOpenInbox: "เปิดกล่องข้อความ",
  intentStepOpenInboxDesc: "สำรวจกล่องข้อความ",
  intentStepAddLead: "เพิ่มลีด",
  intentStepAddLeadDesc: "สร้างลีด CRM รายแรก",

  // Discovery prompt (Plan 40, Epic 04)
  discoveryNotNow: "ไว้ก่อน",
  discoverySetUp: "ตั้งค่า",
  discoveryDismissLabel: "ปิดคำแนะนำนี้",

  // Browse Tools page (Plan 40, Epic 04)
  browseToolsTitle: "สำรวจเครื่องมือ",
  browseToolsSubtitle: "สำรวจเครื่องมือทั้งหมดที่มีสำหรับธุรกิจของคุณ",
  browseToolsActive: "ใช้งานอยู่",
  browseToolsAvailable: "พร้อมใช้งาน",
  browseToolsComingSoon: "เร็วๆ นี้",
  browseToolsSetUp: "ตั้งค่า",
  browseToolsLearnMore: "เรียนรู้เพิ่มเติม",

  // Tool names and descriptions
  toolProducts: "สินค้า",
  toolProductsDesc: "จัดการแคตตาล็อกสินค้า ราคา และสต็อก",
  toolOrders: "คำสั่งซื้อ",
  toolOrdersDesc: "ดำเนินการขายและติดตามการจัดส่ง",
  toolCustomers: "ลูกค้า",
  toolCustomersDesc: "ติดตามความสัมพันธ์กับลูกค้า",
  toolCrm: "CRM",
  toolCrmDesc: "ติดตามลีดและดีลผ่านขั้นตอนการขาย",
  toolInbox: "กล่องข้อความ",
  toolInboxDesc: "แชทกับลูกค้าผ่าน LINE, Facebook และอื่นๆ",
  toolBuilder: "ตัวสร้างหน้าร้าน",
  toolBuilderDesc: "ออกแบบและเผยแพร่หน้าร้านออนไลน์",
  toolInsights: "วิเคราะห์ข้อมูล",
  toolInsightsDesc: "ทำความเข้าใจธุรกิจด้วยแดชบอร์ดภาพ",
  toolSeo: "SEO",
  toolSeoDesc: "ดูว่าลูกค้าค้นเจอร้านคุณบน Google อย่างไร",
  toolAffine: "บันทึก",
  toolAffineDesc: "จัดระเบียบไอเดียและฐานความรู้",
  toolMail: "อีเมล",
  toolMailDesc: "ส่งและรับอีเมลธุรกิจ",

  // Chatwoot pulse tile labels
  chatwootOpenConversations: "แชทที่เปิดอยู่",
  chatwootUnassigned: "แชทที่ยังไม่ได้มอบหมาย",

  // Usage & Plan card (Plan 86, Epic 03)
  usagePlanTitle: "แผนและการใช้งาน",
  usageThisMonth: "เดือนนี้",
  usageUsers: "ผู้ใช้",
  usageOfUnlimitedUsers: "ผู้ใช้ไม่จำกัด",
  usageUser: "ผู้ใช้",
  usageStorage: "พื้นที่จัดเก็บ",
  usageNoFilesYet: "ยังไม่มีไฟล์",
  usageGbIncluded: "GB รวมในแผน",
  usageStorefront: "หน้าร้าน",
  usageStorefronts: "หน้าร้าน",
  usageStorefrontIncluded: "หน้าร้าน (รวมในแผน)",
  usageAppsActive: "แอปที่ใช้งาน",
  usageNoAppsInstalled: "ยังไม่ได้ติดตั้งแอป",
  usageBrowseAppStore: "สำรวจ App Store",
  usageIncluded: "รวมในแผน",
  usageEstimatedTotal: "ค่าใช้จ่ายโดยประมาณ",
  usagePerMonth: "/เดือน",
  usageViewDetails: "ดูรายละเอียด",

  // Usage Detail Page (Plan 86, Epic 04)
  usagePageTitle: "การใช้งานและการเรียกเก็บเงิน",
  usagePlanSummaryTitle: "แผนของคุณ",
  usagePlanName: "แพลตฟอร์มธุรกิจ Zaviago",
  usagePlanPricePerUser: "ต่อผู้ใช้/เดือน",
  usagePlanIncludes: "รวมในแผน",
  usagePlanUnlimitedUsers: "ผู้ใช้ไม่จำกัด",
  usagePlanStorefrontsIncluded: "หน้าร้าน",
  usagePlanStorageIncludedLabel: "GB พื้นที่จัดเก็บ",
  usagePlanBuilder: "Builder (ตัวแก้ไขหน้าเว็บ)",
  usagePlanAddOns: "ส่วนเสริม",
  usagePlanExtraStorefront: "หน้าร้านเพิ่มเติม",
  usagePlanStorageOverage: "พื้นที่จัดเก็บส่วนเกิน",
  usagePlanPerStoreMonth: "/ร้าน/เดือน",
  usagePlanPerGbMonth: "/GB/เดือน",
  usageBreakdownTitle: "การใช้งานปัจจุบัน",
  usageLastUpdated: "อัปเดตล่าสุด",
  usageDataOutdated: "(ข้อมูลอาจล้าสมัย)",
  usageUsersNoLimit: "ไม่จำกัด ผู้ใช้แต่ละคนราคา",
  usageUsersPerMonth: "/เดือน",
  usageStorageIncludedNote: "รวมในแผนของคุณ ส่วนเกิน",
  usageStorefrontIncludedNote: "หน้าร้านรวมในแผน เพิ่มเติม",
  usageActiveAppsTitle: "แอปที่ใช้งาน",
  usageActiveSince: "ใช้งานตั้งแต่",
  usageAppPricingNote: "ราคาแอปจะประกาศเร็วๆ นี้",
  usageNoAppsDetail: "ยังไม่ได้ติดตั้งแอป แอปช่วยขยายแพลตฟอร์มของคุณด้วย CRM, แชท, วิเคราะห์ข้อมูล และอื่นๆ",
  usageCostEstimateTitle: "ค่าใช้จ่ายรายเดือนโดยประมาณ",
  usageCostUsers: "ผู้ใช้",
  usageCostStorage: "พื้นที่จัดเก็บ",
  usageCostStorefront: "หน้าร้าน",
  usageCostApps: "แอป",
  usageCostTotal: "ค่าใช้จ่ายโดยประมาณ",
  usageCostDisclaimer: "นี่เป็นการประมาณ การเรียกเก็บเงินจริงจะเริ่มเมื่อระบบชำระเงินพร้อมใช้งาน",
  usageCostLearnMore: "เรียนรู้เพิ่มเติม",
  usageEach: "แต่ละคน",

  // Business Dashboard (Plan 1921)
  businessDashboardTitle: "แดชบอร์ดธุรกิจ",
  businessDashboardSubtitle: "ภาพรวมผลประกอบการ",
  businessDashboardCustomize: "ปรับแต่ง",
  businessDashboardDone: "เสร็จสิ้น",
  businessDashboardAddWidget: "เพิ่ม Widget",
  businessDashboardReset: "รีเซ็ต",

  // Resource meters (Plan 91, Epic 02)
  usageResourceUnlimited: "ไม่จำกัด",
  usageResourceIncluded: "รวมในแผน",
  usageResourcePerMonth: "เดือนนี้",
  usageResourcePerDay: "วันนี้",
  usageResourceAndMore: "เพิ่มเติม…",
} as const;
